/**
 * @file RedirectLoopFallback.jsx
 * @description Notfall-Fehlerseite, wenn der Circuit Breaker eine Weiterleitungs-Schleife unterbricht.
 */

import { resetRedirectBreaker } from '../utils/redirectBreaker';

/**
 * Notfall-Fehlerseite, wenn der Circuit Breaker eine Schleife unterbricht.
 * @param {object} props
 * @param {() => void} [props.onReset] - Optionaler Callback vor dem Zurücksetzen
 * @returns {JSX.Element}
 */
export default function RedirectLoopFallback({ onReset }) {
  const handleReset = () => {
    resetRedirectBreaker();
    if (typeof onReset === 'function') {
      onReset();
    }
    window.location.href = '/login';
  };

  return (
    <div
      className="global-loading-container"
      style={{
        flexDirection: 'column',
        gap: '1.25rem',
        padding: '2rem',
        textAlign: 'center',
        maxWidth: '520px',
        margin: '3rem auto',
        backgroundColor: 'var(--color-surface, #1e222d)',
        borderRadius: '12px',
        border: '1px solid var(--color-danger, #ef4444)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
      }}
    >
      <div style={{ fontSize: '2rem' }}>⚠️</div>
      <h2 style={{ margin: 0, color: 'var(--color-danger, #ef4444)', fontSize: '1.4rem' }}>
        Weiterleitungs-Schleife unterbrochen
      </h2>
      <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.5', color: 'var(--color-text-muted, #9ca3af)' }}>
        Es wurden ungewöhnlich viele Weiterleitungen in kurzer Zeit festgestellt.
        Um den Browser vor einem Absturz zu schützen, wurde die automatische Weiterleitung gestoppt.
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleReset}
          style={{ padding: '0.6rem 1.2rem', fontWeight: 600 }}
        >
          Sitzung zurücksetzen & zum Login
        </button>
        <button
          type="button"
          className="btn btn-outline"
          onClick={() => {
            resetRedirectBreaker();
            window.location.reload();
          }}
          style={{ padding: '0.6rem 1.2rem' }}
        >
          Seite neu laden
        </button>
      </div>
    </div>
  );
}
